import TrumpProfit from './trump.png';
import SolanaProfit from './solana.png';
import GrassProfit from './grass.png';
import EthereumProfit from './ethereum.png';

const ProfitExamples1 = () => {
  return (
    <div
      style={{
        flex: 1,
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
      }}
    >
      <p style={{ fontSize: 24, fontWeight: 'bold' }}>
        Positive realized profits
      </p>
      <div
        style={{
          display: 'grid',
          gridTemplateRows: 'repeat(2, 1fr)',
          gridTemplateColumns: 'repeat(2, 1fr)',
          height: '100%',
          width: '100%',
        }}
      >
        <div
          style={{
            flex: 1,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <img src={TrumpProfit} style={{ height: '35vh', width: '45vw' }} />
        </div>
        <div
          style={{
            flex: 1,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <img src={SolanaProfit} style={{ height: '35vh', width: '45vw' }} />
        </div>
        <div
          style={{
            flex: 1,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <img src={GrassProfit} style={{ height: '35vh', width: '45vw' }} />
        </div>
        <div
          style={{
            flex: 1,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <img src={EthereumProfit} style={{ height: '35vh', width: '45vw' }} />
        </div>
      </div>
    </div>
  );
};

export default ProfitExamples1;
